var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"title":_vm.title},on:{"close":_vm.handleClose}},[_c('fn-form',_vm._g(_vm._b({ref:"fnForm",on:{"success":_vm.emitClose,"cancel":_vm.handleClose,"validated":_vm.onValidated},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}},'fn-form',_vm.$props,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }